import React, { useEffect } from "react";

import { useLogger } from "../logger";
import { useDataMeshTracking } from "../tracking";
import {
  WNG_HTML_EVENT_ID_PROP_DEPRECATED,
  WNG_NO_WITH_MODULE_CONTEXT,
  WNG_TRACKING_NOT_SENT_HTML_EVENT_ID,
} from "./constants";
import { useDatameshNamespace } from "./DatameshNamespaceProvider";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

const buildTracking = (namespace, id, htmlEventIdProp, logger) => {
  if (!namespace || namespace === "") {
    logger.warn(WNG_NO_WITH_MODULE_CONTEXT);
    return;
  }

  if (!id && !htmlEventIdProp) {
    logger.warn(WNG_TRACKING_NOT_SENT_HTML_EVENT_ID);
    return;
  }

  if (!id) {
    id = htmlEventIdProp;
  } else {
    logger.warn(WNG_HTML_EVENT_ID_PROP_DEPRECATED);
  }

  return { id: `${namespace}-${id}` };
};

export const withTrackComponentDisplayed = (Component, id) => {
  const TrackedComponent = (props) => {
    const logger = useLogger();
    const namespace = useDatameshNamespace();
    const { trackComponentDisplayed } = useDataMeshTracking();

    useEffect(() => {
      const trackingObj = buildTracking(
        namespace,
        id,
        props["html-event-id"],
        logger,
      );
      if (trackingObj) {
        trackComponentDisplayed(trackingObj);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <Component {...props} />;
  };
  TrackedComponent.displayName = `withTrackComponentDisplayed(${getDisplayName(
    Component,
  )})`;
  return TrackedComponent;
};
